import React from 'react'
import ArrowRightSvg from '../assets/icons/ArrowRightSvg'
import './ButtonComp.css'

const ButtonComp = ({ children, onClick, focus }) => {
  return (
    <button onClick={onClick} className={'btnContainer'}>
      <div>{children}</div>
      <div>
        <ArrowRightSvg width={'1rem'} height={'1rem'} focus={focus} />
      </div>
    </button>
  )
}

export default ButtonComp
